import React, { useEffect, useState, Suspense } from "react";
import { EntryConfirmView } from "../Views/form/entryConfirmView";
import { EntryFormView } from "../Views/form/entryFormView";
import { EntrySendView } from "../Views/form/entrySendView";
import { FlowParts } from '../Parts/flowParts'

import { fetchCsrfToken } from '../../data/fetch'
import { useCookies } from "react-cookie";
export const EntryFormPage  = (props) => {   

    window.scrollTo(0,0)
    const [csrfToken, setCsrfToken] = useState(0)
    const [ cookies, setCookie ] = useCookies(['entry']);

    useEffect(() => {
        fetchCsrfToken().then((res) => {
            setCookie('csrfToken', res.csrfToken)
            setCsrfToken(res.csrfToken)
        })
    },[])
    
    //const [InputEntry, setInputEntry] = useRecoilState(inputEntryState);

    const [ InputEntry, setInputEntry] = useState()

    const values = props.defaultValue
    useEffect(() => {

        //コース設定.
        let selectCource
        if(values.questionType === 1){
            selectCource = 'ガス機器購入コース / ガス衣類乾燥機購入コース / LPガスご利用コース' //'ガス機器購入コース / ガス衣類乾燥機購入コース / LPガスご利用コース'
        }else if(values.questionType === 2){
            selectCource = 'ガス機器購入コース / LPガスご利用コース' //'ガス衣類乾燥機購入コース / LPガスご利用コース'
        }else if(values.questionType === 3){
            selectCource = 'LPガスご利用コース'  //'LPガスご利用コース'
        }else{}

        //購入商品.
        const products = values.questionType === 3 ? null : values.apply.map( (app) => {
            return `${app.product.name} 【${app.product.maker}】 ${ app.product.kantakun ?  app.product.kantakun : ''} / 購入日 ${app.product.buyDate}` 
        })

        //購入店
        const store = `${values.store.name} ${values.store.address}` 

        //プレゼント
        const presents = values.questionType === 3 ? null : values.apply.map( (app) => {
            return app.present.color ? `${app.present.name} 【${app.present.color}】` : app.present.name 
        })

        setInputEntry({
            cource: selectCource,
            products: products,
            store: store, // 新しい store プロパティの値
            presents: presents
        })

    },[values])

    const [fromValue, setFromValue] = useState(
        !props.defaultValue.formValue ? {
        name:'',
        address:'',
        sex:'選択しない',
        age:'20代',
        agree:false
    } : props.defaultValue.formValue)

    const [formFlow, setFormFlow] = useState('form')

    const onConfirm = (values) => 
    {
        setFormFlow('confirm')
        setFromValue(values)
        props.setFormValue(values)
    }

    const offConfirm = () => {
        setFormFlow('form')
    }

    const onSend = () => {
        const updatedInputEntry = {
            ...InputEntry, // 既存のプロパティをコピー
            ...fromValue, 
        };
        setInputEntry(updatedInputEntry)
        setFormFlow('send')
    }    

    
    return(
        <>
        <div className="select">
          
          
            { formFlow === 'form' && csrfToken !== 0 &&
            <>
                <FlowParts {...{flow:'flow3'}}></FlowParts>
                <div className="select_content">
                <EntryFormView {...{fromValue, onConfirm, prev:props.prev}}></EntryFormView>
                </div>
            </>
            }
            { formFlow === 'confirm' &&
            <>
                <FlowParts {...{flow:'flow3'}}></FlowParts>
                <div className="select_content">
                <EntryConfirmView {...{fromValue, onSend, offConfirm, InputEntry}}></EntryConfirmView>
                </div>
            </>
            }
            { formFlow === 'send' &&
                <EntrySendView {...{InputEntry, setFormFlow}}></EntrySendView>
            }
        </div>
        </>
    )
}